import ChallengeSetDetails from '@/src/components/challenges/challengeSets/ChallengeSetDetails';
import React from 'react';

export const ChallengeSetDetailsPage: React.FC = () => {
  return <ChallengeSetDetails />;
};
